import styled from 'styled-components';

export default styled.div`
  position: absolute;
  top: 10px;
  right: 7px;
  color: #edece8;
  font-size: 12px;
`;
